'use client';

/* eslint-disable react/no-use-context */

import { createContext, useContext } from 'react';

export type PwaInstallContextValue = {
  isInstallAvailable: boolean;
  isStandalone: boolean;
  isAppleDevice: boolean;
  canDirectInstall: boolean;
  shouldShowFloatingCta: boolean;
  shouldShowInstallInPushSettings: boolean;
  startInstallFlow: () => void;
  openInstallDialog: () => void;
  handleInstallAccepted: () => void;
};

export const PwaInstallContext = createContext<PwaInstallContextValue | null>(null);

export function usePwaInstall(): PwaInstallContextValue {
  const context = useContext(PwaInstallContext);

  if (!context) {
    throw new Error('usePwaInstall must be used within PwaInstallProvider');
  }

  return context;
}
